import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: import.meta.env.SENTRY_DSN_FE,
  release: window.APP_SENTRY_RELEASE || undefined,
  environment: import.meta.env.APP_ENV,
});
